import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const filterParams = (f) => {
  const p = {};
  Object.entries(f || {}).forEach(([k, v]) => {
    if (v && v !== "all") p[k] = v;
  });
  return p;
};

export const API_BASE = API;
